<template>
  <div class="file-download">
    <a-breadcrumb>
      <a-breadcrumb-item>文档</a-breadcrumb-item>
      <a-breadcrumb-item>Portfolio文件收集</a-breadcrumb-item>
    </a-breadcrumb>

    <a-modal title="编辑说明" :visible="isDescription" @ok="modifyDescription()" @cancel="e => handleCancel(e, 'description')">
      <div class="padding-10">
        <p>当前季度说明:</p>
        <p>{{ description }}</p>
        <div style="margin-top:45px"></div>
        <!-- <a-divider /> -->
        <p>更新为:</p>
        <a-textarea placeholder="" :rows="4" v-model="descriptionNew" />
        <div class="alert-msg">配置内容外部公司页面可见,请谨慎填写</div>
      </div>
    </a-modal>
    <a-modal title="发布评论" :visible="isComment" @ok="addComment()" @cancel="e => handleCancel(e, 'comment')">
      <a-textarea placeholder="请输入要评论的内容" :rows="4" v-model="commentNow" />
      <div class="alert-msg">评论内容外部公司页面可见,请谨慎填写</div>
    </a-modal>
    <a-modal title="代传作业" destroyOnClose :maskClosable="false" :visible="isUpload" @ok="handleOk()" @cancel="e => handleCancel(e, 'upload')">
      <div class="upload-info">
        <div>所属时间周期</div>
        {{ listTitle[tabNow] }} <br />
        <div>所属项目</div>
        {{ companyNameNow }} <br />
        <div>上传作业至</div>
        {{ templateNameNow }}
      </div>
      <a-upload-dragger name="file" :multiple="true" :action="uploadAction" :headers="headers" :data="getUploadObj" :remove="removeFile" @change="handleChange">
        <p class="ant-upload-drag-icon">
          <a-icon type="inbox" />
        </p>
        <p class="ant-upload-text">
          直接拖拽文件到此处即可上传，或点击
          <a>点击上传</a>
        </p>
        <p class="ant-upload-hint">（单个文件最大500MB）</p>
      </a-upload-dragger>
      <div class="alert-msg">配置外部公司页面可见,请谨慎填写</div>
      <template slot="footer">
        <a-button key="submit" type="primary" @click="handleOk">
          确定
        </a-button>
      </template>
    </a-modal>
    <div class="task-content">
      <div class="list-header-top space-20">
        <!--      <div class="display: flex; justify-content: flex-start;margin: 20px 0;">-->
        <a-button data-ga-id="文档-文件收集-点击创建作业" v-if="permissions.hasCreate" type="primary" @click="toPath('createTask')">创建作业</a-button>
        <a-button v-if="permissions.hasEditMember" class="gap-l-10" @click="toPath('editMember')">项目人员维护</a-button>
      </div>
      <div class="list-header space-20">
        <a-spin :spinning="loading">
          <div class="flex">
            <div class="flex center">
              <span class="gap-10">快捷筛选:</span>
              <!-- -1-全部，0-未完成，1-已完成，不传默认-1 -->
              <span :class="{ 'filter-selected': filterNow === -1, 'filter-unselected': filterNow !== -1 }" @click="filterChange($event, -1)">全部</span>
              <span class="gap-10">|</span>
              <span :class="{ 'filter-selected': filterNow === 1, 'filter-unselected': filterNow !== 1 }" @click="filterChange($event, 1)">已完成</span>
              <span class="gap-10">|</span>
              <span :class="{ 'filter-selected': filterNow === 0, 'filter-unselected': filterNow !== 0 }" @click="filterChange($event, 0)">未完成</span>
              <span class="gap-10"></span>
            </div>
            <!--            <a-input-search @search="handleSearch" placeholder="按基金名称搜索" v-model="investFundNameKeyword" style="width: 200px" />-->
            <a-select
              mode="multiple"
              placeholder="按基金名称搜索"
              v-model="investFundNameKeyword"
              @search="fetchInvestFundName"
              @dropdownVisibleChange="dropdownVisibleChange"
              :filterOption="false"
              style="width: 150px"
            >
              <a-select-option v-for="item in listInvestFundName" :key="item.id" :value="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
            <span class="gap-10"></span>
            <a-input-search @search="handleSearch" placeholder="按项目名称搜索" v-model="keyword" style="width: 150px" />
            <span class="gap-10"></span>
            <a-input-search @search="handleSearch" placeholder="按作业模版搜索" v-model="taskFileNameKeyword" style="width: 150px" />
            <span class="gap-10"></span>
            <a-date-picker v-model="fileUploadStartTime" placeholder="文件上传起始时间" format="YYYY-MM-DD HH:mm:ss" style="width: 180px" />
            <span class="gap-10"></span>
            <a-date-picker v-model="fileUploadEndTime" placeholder="文件上传截止时间" format="YYYY-MM-DD HH:mm:ss" style="width: 180px" />
            <!--            <a-button class="btn-query" @click="handleSearch">查询</a-button>-->
          </div>
          <div class="list-header-end space-20">
            <a-button class="btn-query" @click="handleSearch">查询</a-button>
            <span class="gap-10"></span>
            <div class="btn" v-if="isChooseDownload">
              <a-button class="btn-query" @click="cancelDownload">取消下载</a-button>
              <span class="gap-10"></span>
              <a-button type="danger" @click="downLoad">下载（{{ downloadList.length }}/300）</a-button>
            </div>
            <div class="btn" v-else>
              <a-button data-ga-id="文档-Portfolio文件收集-点击下载" type="danger" @click="chooseDownload" v-if="permissions.hasDownloadTask"
                >选择下载</a-button
              >
            </div>
          </div>
        </a-spin>
      </div>
      <!-- tab -->
      <div style="width: auto">
        <a-tabs
          :default-active-key="listTitle[0]"
          :tab-position="mode"
          :style="{ height: 'auto' }"
          :animated="false"
          @change="tabChange"
          @prevClick="callback"
          @nextClick="callback"
        >
          <a-tab-pane v-for="i in listTitle" :key="i" :tab="i">
            <div class="tab-description">
              阶段作业说明：{{ description ? description : '暂无说明' }}
              <a data-ga-id="文档-文件收集-点击编辑作业说明" v-if="permissions.hasEditDescription && !tableLoading" @click="showDescription">编辑</a>
            </div>
          </a-tab-pane>
        </a-tabs>
        <!-- table -->
        <a-table :columns="columns" :data-source="tableData" :pagination="false" class="file-table" :key="tableKey" :loading="tableLoading">
          <div slot="companyPerson" slot-scope="person" href="javascript:;">
            <div v-for="i in person" :key="i">
              {{ i }}
              <br />
            </div>
          </div>

          <div slot="template" slot-scope="template" href="javascript:;">
            <a-popover v-if="permissions.hasDownloadTemplate">
              <template slot="content">
                <a-button size="small" type="primary" @click="downloadFile(1, template.taskId, template.template.id)">下载</a-button>
              </template>
              <a class="file-name" @click="toPdfView(template.template.id, template.taskId, 1)">{{ template.template.name }}</a>
            </a-popover>
            <a class="file-name" @click="toPdfView(template.template.id, template.taskId, 1)" v-else>{{ template.template.name }}</a>
          </div>
          <div slot="finish" slot-scope="finish" href="javascript:;">
            <a-popover placement="topLeft">
              <!-- 有评论的就展示 没有的就不展示浮层 -->
              <div slot="content" class="comment" v-if="finish.comments.length > 0">
                <p v-for="(i, index) in finish.comments" :key="index" :class="{ blue: i.source === 1 }">- {{ i.content }}</p>
              </div>
              <div v-for="(i, index) in finish.finish" :key="i.id">
                <a data-ga-id="文档-文件收集-点击作业预览" @click="toPdfView(i.id, finish.taskId, 2)">
                  <del class="file-name-del" v-if="i.status === -2">{{ i.name }}</del>
                  <span class="file-name" v-else>{{ i.name }}</span></a
                >
                <span class="file-table-finish-time"> {{ finish.uploadDate[index] }} </span>
                <a data-ga-id="文档-文件收集-点击作业下载" v-if="permissions.hasDownloadTask && !isChooseDownload" @click="downloadFile(2, finish.taskId, i.id)"
                  >下载</a
                >
                <a @click="deleteCompanyFile(finish.companyId, i.id, i.name)">
                  删除
                </a>
                <a-checkbox
                  class="dowload-check"
                  :checked="i.check"
                  v-if="permissions.hasDownloadTask && isChooseDownload"
                  @change="e => onChangeCheck(e, finish.taskId, i.id, finish.companyName)"
                ></a-checkbox>
                <br />
              </div>
            </a-popover>
          </div>
          <span slot="action" slot-scope="text" href="javascript:;">
            <a-button data-ga-id="文档-文件收集-点击代传" v-if="permissions.hasProxyUpload" size="small" @click="showUpload(text)">代传</a-button>
            <a-button
              data-ga-id="文档-文件收集-点击评论"
              style="margin-left:8px;"
              v-if="text.finish.length && permissions.hasComment"
              type="primary"
              size="small"
              @click="showComment(text)"
              >评论</a-button
            >
          </span>
        </a-table>
        <!-- table -->
        <!-- 分页 -->
        <div class="pagination-buttom">
          <a-pagination
            :page-size-options="pageSizeOptions"
            show-size-changer
            @showSizeChange="handlePageSizeChange"
            v-model="current"
            :total="total"
            :page-size="pageSize"
            @change="onChange"
            :show-total="total => `共有 ${total} 条数据`"
          >
          </a-pagination>
        </div>
        <!-- 分页end -->
      </div>
    </div>
  </div>
</template>
<script lang="jsx">
import { quarterQuery, taskQuery, commentAdd, descriptionModify, fileDownload,fileDownloadZip,queryInvestFundList, proxyDeleteCompanyFile } from '@/api/document';
import { downloadFile as downloadFileApi } from 'assets/js/download';
import { downloadFile } from '@/assets/js/download';
import { mapGetters } from 'vuex';
import { hasPermission } from '@/utils/utils';
import moment from 'moment';

const tableData = [];

export default {
  data() {
    return {
      columns: [
        {
          title: '基金名称',
          dataIndex: 'investFundName',
          key: 'investFundName',
          // fixed: 'left',
          width: '10%',
          customRender: (value, row, index) => {
            const data = {
              children: value,
              attrs: {
                rowSpan: row.rowSpan
              },
            };
            return data;
          }
        },
        {
          title: '项目名称',
          dataIndex: 'companyName',
          key: 'companyName',
          // fixed: 'left',
          width: '10%',
          customRender: (value, row, index) => {
            const data = {
              children: [
                this.isChooseDownload ?
                  <a-checkbox
                    checked={row.check}
                    onChange={(e) => this.handleCheckboxChange(e, row)}
                    style={{ marginRight: '8px' }}
                  ></a-checkbox> : null,
                value
              ],
              attrs: {
                rowSpan: row.rowSpan
              },
            };
            return data;
          }
        },
        {
          title: '文件催收人',
          dataIndex: 'urgeNames',
          key: 'urgeNames',
          width: '8%',
          customRender: (value, row, index) => {
            // console.log(value);
            const data = {
              children: value,
              attrs: {
                rowSpan: row.rowSpan
              },
            };
            return data;
          }
        },
        {
          title: '公司对接人',
          dataIndex: 'companyPerson',
          key: 'companyPerson',
          width: '10%',
          customRender: (value, row, index) => {
            const data = {
              children: value ? value.map(_ => <span>{_}<br/></span>) : <span></span>,
              attrs: {
                rowSpan: row.rowSpan
              },
            };
            return data;
          },
        },
        { title: '作业模板', width: '20%', key: 'template', scopedSlots: { customRender: 'template' } },
        {
          title: '截止时间',
          dataIndex: 'ddl',
          key: 'ddl',
          width: '9%'
        },
        { title: () => {return this.isChooseDownload ? (<span>已上传文件<a-checkbox style="margin-left:10px" onChange={this.onFinishCheckboxChange}  ></a-checkbox></span>) : '已上传文件';},
          key: 'finish', width: '30%', scopedSlots: { customRender: 'finish' } },
        { title: '操作', dataIndex: '', key: 'x', width: '12%', scopedSlots: { customRender: 'action' } }
      ],
      fileList: [],
      uploadAction: process.env.VUE_APP_BASE_API + '/gather/proxyUploadCompanyFile',
      tableKey: true,
      taskIdNow: 0,
      descriptionNew: '',
      filterNow: -1,
      ModalText: 'Content of the modal',
      visible: false,
      isComment: false,
      isUpload: false,
      tableData,
      keyword: '',
      investFundNameKeyword: [],
      taskFileNameKeyword: '',
      mode: 'top',
      listTitle: [],
      listQuarter: [],
      tabNow: 0,
      description: '',
      isDescription: false,
      commentNow: '',
      current: 1,
      pageSizeOptions: ['10', '20', '50', '100'],
      pageSize: 20,
      total: 0,
      permissions: {
        hasCreate: true,
        hasEditMember: true,
        hasEditDescription: true,
        hasComment: true,
        hasDownloadTemplate: true,
        hasDownloadTask: true,
        hasProxyUpload: true
      },
      companyNameNow: '',
      companyIdNow: 0,
      templateNameNow: '',
      tableLoading: false,
      isChooseDownload: false,
      loading:false,
      downloadList: [],
      fileUploadStartTime: null,
      fileUploadEndTime: null, // 存储截止时间
      listInvestFundName: []

      // listTitle: ['2021年Q2','2021年Q1','2020年年度','2020年Q4','2020年Q3','2020年Q2','2020年Q1','2019年年度','2019年Q4','2019年Q3','2019年Q2','2019年Q1','2018年年度'],
    };
  },
  created() {
    this.getQuarterQuery();
    this.getPermissions();
    this.fetchOptions();
  },
  mounted() {},
  computed: {
    ...mapGetters(['userInfo','token']),
    headers() {
      return { Authorization: this.token };
    }
  },
  methods: {
    toPdfView(fileId, taskId, type) {
      let fileType = type === 1 ? 'template' : 'finish';
      window.open(window.location.origin + `/pdfview/${fileType}?id=${fileId}&taskId=${taskId}`);
    },
    getPermissions() {
      const { permissions:queue } = this.userInfo || {};
      this.permissions.hasCreate = hasPermission(queue, '/document/fileCollection/createTask');
      this.permissions.hasEditMember = hasPermission(queue, '/document/fileCollection/editMember');
      this.permissions.hasEditDescription = hasPermission(queue, '/document/fileCollection/editDescription');
      this.permissions.hasComment = hasPermission(queue, '/document/fileCollection/addComment');
      this.permissions.hasDownloadTemplate = hasPermission(queue, '/document/fileCollection/download');
      this.permissions.hasDownloadTask = hasPermission(queue, '/document/fileCollection/download');
      this.permissions.hasProxyUpload = hasPermission(queue, '/document/fileCollection/proxyUploadCompanyFile');
    },
    toPath(pathTo) {
      this.$router.push({ path: '/document/fileCollection/' + pathTo });
    },
    // fileList变化触发
    handleChange(info) {
      const status = info.file.status;
      if (status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (status === 'done') {
        let res = info.file.response;
        if (res.code === 200) {
          this.$message.success(`${info.file.name} 上传成功`);
        } else {
          this.$message.error(res.msg);
          this.fileList = this.fileList.filter(_ => _.response.code === 200);
        }
      } else if (status === 'error') {
        this.$message.error(`${info.file.name} 上传失败`);
      }
    },
    // 点击fileList删除按钮
    async removeFile(file) {
      try {
        let res = await proxyDeleteCompanyFile({
          portfolioId: this.companyIdNow,
          fileId: file.response.data
        });
        if (res.code === 200) {
          this.$message.success('删除成功');
        }
      } catch (err) {
        console.log(err);
      }
    },
    // upload组件data
    getUploadObj(file) {
      return {
        taskId: this.taskIdNow || '',
        portfolioId: this.companyIdNow
      };
    },
    // 分页change
    onChange(page, pageSize) {
      let i = this.tabNow;
      let fileUploadStartTime = "";
      if(this.fileUploadStartTime !== null && this.fileUploadStartTime !==undefined){
        fileUploadStartTime = this.fileUploadStartTime.format('YYYY-MM-DD HH:mm:ss');
      }
      let fileUploadEndTime = "" ;
      if(this.fileUploadEndTime !== null && this.fileUploadEndTime !== undefined){
        fileUploadEndTime = this.fileUploadEndTime.format('YYYY-MM-DD HH:mm:ss');
      }
      this.getTaskQuery({
        year: this.listQuarter[i].year,
        quarter: this.listQuarter[i].quarter,
        complete: this.filterNow,
        searchName: this.keyword,
        searchInvestFundIds: this.investFundNameKeyword.join(','),
        searchTaskFileName: this.taskFileNameKeyword,
        fileUploadStartTime: fileUploadStartTime,
        fileUploadEndTime: fileUploadEndTime,
        page: page,
        pageSize: pageSize
      });
    },

    handlePageSizeChange(current, pageSize) {
      // 处理每页显示条数变化的方法
      this.pageSize = pageSize;
      this.current = 1;
      this.onChange(1,this.pageSize); // 重新获取第一页数据
    },


    // 处理复选框变化
    handleCheckboxChange(e, row) {
      const checked = e.target.checked;
      row.check = checked;
      // console.log('handleCheckboxChange',e, row);
      // 更新当前行的所有已上传文件的勾选状态
      // if (row.finish) {
      //   row.finish.forEach(item => {
      //     item.check = checked;
      //   });
      // }

      this.tableData.forEach(thisRow => {
        if (thisRow.finish && thisRow.companyId === row.companyId) {
          thisRow.finish.forEach(item => {
            item.check = checked;
          });
        }
      });

      if (e.target.checked) {
        this.tableData.forEach(thisRow => {
          if (thisRow.finish && thisRow.companyId === row.companyId) {
            thisRow.finish.forEach(item => {
              let obj ={
                taskId : thisRow.taskId,
                fileId:item.id,
                folder:thisRow.companyName
              };
              this.downloadList.push(obj);
            });
          }
        });
      }else{
        this.downloadList = this.downloadList.filter(e => e.folder !== row.companyName);
      }


      // 更新表格数据
      // this.tableData = [...this.tableData];  // 强制更新表格
    },
    onFinishCheckboxChange(e){
      // console.log('onFinishCheckboxChange.start',e);
      const checked = e.target.checked;
      this.tableData.forEach(row => {
        row.check = checked;
        if (row.finish) {
          row.finish.forEach(item => {
            item.check = checked;
          });
        }
      });
      if (e.target.checked && this.downloadList.length >= 300) {
        this.$message.error('选择的文件个数超过限制');
        this.checked = false;
      }
      if (e.target.checked) {
        this.downloadList = [];
        this.tableData.forEach(row => {
          if (row.finish) {
            row.finish.forEach(item => {
              let obj ={
                taskId : row.taskId,
                fileId:item.id,
                folder:row.companyName
              };
              this.downloadList.push(obj);
            });
          }
        });
      }else{
        this.downloadList = [];
      }
    },
    onChangeCheck(e,taskId, id,companyName) {
      this.tableData.forEach(e1 => {
        if(e1.taskId === taskId){
          e1.finish.forEach(e2 => {
            if(e2.id === id){
              e2.check = e.target.checked;
            }
          });
        }
      });
      if (e.target.checked && this.downloadList.length >= 300) {
        this.$message.error('选择的文件个数超过限制');
        this.checked = false;
      }

      if (e.target.checked) {
        let obj ={
          taskId : taskId,
          fileId:id,
          folder:companyName
        };
        // 判断是否已经存在
        let isExist = this.downloadList.some(e => e.fileId === id && e.taskId === taskId);
        if(!isExist){
          this.downloadList.push(obj);
        }
      }else{
        this.downloadList = this.downloadList.filter(e => e.fileId !== id);
      }

    },
    // 筛选change
    filterChange(e, key) {
      this.$ga.gaUploadCustomEvent('文档-文件收集-筛选已完成/未完成',key);
      let i = this.tabNow;
      this.filterNow = key;
      let fileUploadStartTime = "";
      if(this.fileUploadStartTime !== null && this.fileUploadStartTime !==undefined){
        fileUploadStartTime = this.fileUploadStartTime.format('YYYY-MM-DD HH:mm:ss');
      }
      let fileUploadEndTime = "" ;
      if(this.fileUploadEndTime !== null && this.fileUploadEndTime !== undefined){
        fileUploadEndTime = this.fileUploadEndTime.format('YYYY-MM-DD HH:mm:ss');
      }
      this.getTaskQuery({
        year: this.listQuarter[i].year,
        quarter: this.listQuarter[i].quarter,
        complete: this.filterNow,
        searchName: this.keyword,
        searchInvestFundIds: this.investFundNameKeyword.join(','),
        searchTaskFileName: this.taskFileNameKeyword,
        fileUploadStartTime: fileUploadStartTime,
        fileUploadEndTime: fileUploadEndTime,
        pageSize: this.pageSize
      });
    },

    async fetchOptions() {
      try {
        let res = await queryInvestFundList('');
        if (res.code === 200) {
          this.listInvestFundName = res.data;

        }
      } catch (err) {
        console.log(err);
      }

    },


    fetchInvestFundName(value){
      queryInvestFundList(value).then(res => {
        if (res.code === 200) {
          this.listInvestFundName = res.data;
        }
      });
    },

    dropdownVisibleChange(open) {
      open && this.fetchInvestFundName('');
    },

    // 搜索
    handleSearch() {
      this.$ga.gaUploadCustomEvent('文档-文件收集-搜索名称');
      let i = this.tabNow;
      let fileUploadStartTime = "";
      if(this.fileUploadStartTime !== null && this.fileUploadStartTime !==undefined){
        fileUploadStartTime = this.fileUploadStartTime.format('YYYY-MM-DD HH:mm:ss');
      }
      let fileUploadEndTime = "" ;
      if(this.fileUploadEndTime !== null && this.fileUploadEndTime !== undefined){
        fileUploadEndTime = this.fileUploadEndTime.format('YYYY-MM-DD HH:mm:ss');
      }

      // console.log("handleSearch",fileUploadStartTime,fileUploadStartTime);
      this.getTaskQuery({
        year: this.listQuarter[i].year,
        quarter: this.listQuarter[i].quarter,
        searchName: this.keyword,
        searchInvestFundIds: this.investFundNameKeyword.join(','),
        searchTaskFileName: this.taskFileNameKeyword,
        complete: this.filterNow,
        fileUploadStartTime:fileUploadStartTime,
        fileUploadEndTime:fileUploadEndTime,
        pageSize: this.pageSize
      });
    },
    // tab change
    tabChange(val) {
      this.$ga.gaUploadCustomEvent('文档-文件收集-切换季度tab');
      this.tabNow = this.listTitle.indexOf(val);
      // console.log('tabChange', val);
      let i = this.tabNow;
      this.getTaskQuery({
        year: this.listQuarter[i].year,
        quarter: this.listQuarter[i].quarter,
        pageSize: this.pageSize
      });
      this.keyword = '';
      this.investFundNameKeyword = [];
      this.taskFileNameKeyword = '';
      this.filterNow = -1;
      this.fileUploadStartTime = null;
      this.fileUploadEndTime = null;
    },
    // tab左右滑动
    callback(val) {
      // console.log(val);
    },
    showComment(row) {
      // console.log('row', row);
      this.isComment = true;
      this.taskIdNow = row.taskId;
    },
    showUpload(row) {
      // console.log('row', row);

      this.isUpload = true;
      this.taskIdNow = row.taskId;
      this.companyNameNow = row.companyName;
      this.companyIdNow = row.companyId;
      this.templateNameNow = row.template.name;
    },
    showDescription() {
      this.isDescription = true;
    },
    handleCancel(e, type) {
      if (type === 'upload') {
        this.isUpload = false;
        let i = this.tabNow;
        let fileUploadStartTime = "";
        if(this.fileUploadStartTime !== null && this.fileUploadStartTime !==undefined){
          fileUploadStartTime = this.fileUploadStartTime.format('YYYY-MM-DD HH:mm:ss');
        }
        let fileUploadEndTime = "" ;
        if(this.fileUploadEndTime !== null && this.fileUploadEndTime !== undefined){
          fileUploadEndTime = this.fileUploadEndTime.format('YYYY-MM-DD HH:mm:ss');
        }
        this.getTaskQuery({
          year: this.listQuarter[i].year,
          quarter: this.listQuarter[i].quarter,
          complete: this.filterNow,
          searchName: this.keyword,
          searchInvestFundIds: this.investFundNameKeyword.join(','),
          searchTaskFileName: this.taskFileNameKeyword,
          fileUploadStartTime: fileUploadStartTime,
          fileUploadEndTime: fileUploadEndTime,
          page: this.current,
          pageSize: this.pageSize
        });
      } else if (type === 'comment') {
        this.isComment = false;
        this.commentNow = '';
      } else if (type === 'description') {
        this.isDescription = false;
        this.descriptionNew = '';
      }
    },
    handleOk() {
      this.isUpload = false;
      let i = this.tabNow;
      let fileUploadStartTime = "";
      if(this.fileUploadStartTime !== null && this.fileUploadStartTime !==undefined){
        fileUploadStartTime = this.fileUploadStartTime.format('YYYY-MM-DD HH:mm:ss');
      }
      let fileUploadEndTime = "" ;
      if(this.fileUploadEndTime !== null && this.fileUploadEndTime !== undefined){
        fileUploadEndTime = this.fileUploadEndTime.format('YYYY-MM-DD HH:mm:ss');
      }
      this.getTaskQuery({
        year: this.listQuarter[i].year,
        quarter: this.listQuarter[i].quarter,
        complete: this.filterNow,
        searchName: this.keyword,
        searchInvestFundIds: this.investFundNameKeyword.join(','),
        searchTaskFileName: this.taskFileNameKeyword,
        fileUploadStartTime: fileUploadStartTime,
        fileUploadEndTime: fileUploadEndTime,
        page: this.current,
        pageSize: this.pageSize
      });
    },
    // 查询季度 quarterQuery
    async getQuarterQuery() {
      try {
        let res = await quarterQuery();
        // console.log('quarterGet');
        if (res.code === 200) {
          this.listQuarter = res.data;
          this.listTitle = this.changeQuarterList(res.data);
          this.getTaskQuery({
            year: this.listQuarter[0].year,
            quarter: this.listQuarter[0].quarter,
            pageSize: this.pageSize
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 将季度信息转化为tab标题
    changeQuarterList(quarter) {
      let tmpList = [];
      quarter.forEach(e => {
        tmpList.push(e.quarter === 5 ? e.year + '年年度' : e.year + '年Q' + e.quarter);
      });
      return tmpList;
    },
    // 查询作业 taskQuery
    // 传入参数
    async getTaskQuery(body) {
      try {
        this.tableLoading = true;
        let res = await taskQuery(body);
        if (res.code === 200) {
          // 加了这个之后表格会重新渲染,不知道为什么不加的话会有数据错行
          this.tableKey = !this.tableKey;
          this.description = res.data.description;
          this.tableData = this.changeTaskList(res.data.detail.list);
          this.total = res.data.detail.total;
          this.downloadList = [];
        }
        this.tableLoading = false;
      } catch (err) {
        console.log(err);
      }
    },
    cancelDownload() {
      this.isChooseDownload = false;
      this.downloadList = [];
      // 将check框都置为false
      this.tableData.forEach(e1 => {
        e1.check = false;
        e1.finish.forEach(e2 => {
          e2.check = false;
        });
      });
    },
    async downLoad() {
      if (this.downloadList.length > 300) {
        this.$message.error('选择的文件个数超过限制');
      } else if (this.downloadList.length === 0) {
        this.$message.error('请选择下载文件');
      } else {
        try {
          this.loading = true;
          let downloadList = this.downloadList;
          let res = await fileDownloadZip({
            type:2,
            fileDownloadList: downloadList
          });
          if (res.code === 200) {
            this.loading = false;
            const downloadPath = res.data + '?Authorization=' + this.token;
            downloadFile(downloadPath);
            this.isChooseDownload = false;
            this.downloadList = [];
            // 将check框都置为false
            this.tableData.forEach(e1 => {
              e1.check = false;
              e1.finish.forEach(e2 => {
                e2.check = false;
              });
            });
          }
          else {
            this.$message.error('下载失败');
            this.loading = false;
          }
        } catch (err) {
          this.loading = false;
          this.$message.error('下载失败');
          console.log(err);
        }
      }
    },
    chooseDownload() {
      this.isChooseDownload = true;
      // this.$router.push({ path: '/document/fileCollection/download' });
    },
    // 将拿到的任务数据转换为表格数据
    changeTaskList(taskData) {
      let index = 0;
      let tableTmp = [];
      taskData.forEach(e => {
        let tmp1 = {};
        tmp1.investFundName = e.investFundName;
        tmp1.companyName = e.companyName;
        tmp1.check = false;
        tmp1.companyId = e.companyId;
        tmp1.urgeNames = e.urgeNames;
        tmp1.companyPerson = [e.contact, e.email, e.phone];
        tmp1.rowSpan = e.tasks ? e.tasks.length : '1';
        tmp1.key = e.tasks ? index : ++index;
        if (e.tasks) {
          e.tasks.forEach((e2, index2) => {
            let tmp2 = {};
            if (index2 === 0) {
              tmp2 = tmp1;
            } else {
              tmp2.companyName = tmp1.companyName;
              tmp2.companyId = tmp1.companyId;
              tmp2.check = tmp1.check;
            }
            tmp2.key = ++index;
            tmp2.taskId = e2.id;
            tmp2.template = {
              name: e2.fileName,
              id: e2.fileId
            };
            tmp2.ddl = moment.unix(e2.deadline).format('YYYY-MM-DD');
            tmp2.finish = [];
            tmp2.uploadDate = [];
            tmp2.comments = [];
            if (e2.companyFiles) {
              let tmp3 = [];
              e2.companyFiles.forEach(e3 => {
                tmp2.finish.push({ name: e3.fileName, id: e3.fileId, status: e3.status, check: false,canDelete:e3.canDelete });
                let formatTmp = moment.unix(e3.createAt).format('YYYY-MM-DD HH:mm');
                // console.log('formatTmp',e3.createAt,formatTmp);
                tmp2.uploadDate.push(formatTmp);
              });
            }
            if (e2.comments) {
              e2.comments.forEach(e4 => {
                // 加一个source 0: 源码内部，1:portfolio
                let formatTmp = moment.unix(e4.createAt).format('YYYY-MM-DD HH:mm');
                tmp2.comments.push({ source: e4.source, content: e4.comment + ' by' + (e4.source === 0 ? e4.createPerson : '公司') + ' ' + formatTmp });
              });
            }
            if (index2 !== 0) tmp2.rowSpan = 0;
            tableTmp.push(tmp2);
          });
        }
      });
      return tableTmp;
    },
    // 新增评论 commentAdd
    async addComment() {
      // console.log(this.taskIdNow, this.commentNow);
      try {
        let res = await commentAdd({
          taskId: this.taskIdNow,
          comment: this.commentNow
        });
        if (res.code === 200) {
          this.$message.success('评论成功');
          this.isComment = false;
          this.commentNow = '';
          let i = this.tabNow;
          let fileUploadStartTime = "";
          if(this.fileUploadStartTime !== null && this.fileUploadStartTime !==undefined){
            fileUploadStartTime = this.fileUploadStartTime.format('YYYY-MM-DD HH:mm:ss');
          }
          let fileUploadEndTime = "" ;
          if(this.fileUploadEndTime !== null && this.fileUploadEndTime !== undefined){
            fileUploadEndTime = this.fileUploadEndTime.format('YYYY-MM-DD HH:mm:ss');
          }
          this.getTaskQuery({
            year: this.listQuarter[i].year,
            quarter: this.listQuarter[i].quarter,
            complete: this.filterNow,
            searchName: this.keyword,
            searchInvestFundIds: this.investFundNameKeyword.join(','),
            searchTaskFileName: this.taskFileNameKeyword,
            fileUploadStartTime: fileUploadStartTime,
            fileUploadEndTime: fileUploadEndTime,
            page: this.current,
            pageSize: this.pageSize
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 编辑作业说明 descriptionModify
    async modifyDescription() {
      try {
        let i = this.tabNow;
        let res = await descriptionModify({
          year: this.listQuarter[i].year,
          quarter: this.listQuarter[i].quarter,
          description: this.descriptionNew
        });
        if (res.code === 200) {
          this.$message.success('编辑成功');
          this.isDescription = false;
          this.descriptionNew = '';
          let i = this.tabNow;
          let fileUploadStartTime = "";
          if(this.fileUploadStartTime !== null && this.fileUploadStartTime !==undefined){
            fileUploadStartTime = this.fileUploadStartTime.format('YYYY-MM-DD HH:mm:ss');
          }
          let fileUploadEndTime = "" ;
          if(this.fileUploadEndTime !== null && this.fileUploadEndTime !== undefined){
            fileUploadEndTime = this.fileUploadEndTime.format('YYYY-MM-DD HH:mm:ss');
          }
          this.getTaskQuery({
            year: this.listQuarter[i].year,
            quarter: this.listQuarter[i].quarter,
            complete: this.filterNow,
            searchName: this.keyword,
            searchInvestFundIds: this.investFundNameKeyword.join(','),
            searchTaskFileName: this.taskFileNameKeyword,
            fileUploadStartTime: fileUploadStartTime,
            fileUploadEndTime:fileUploadEndTime,
            page: this.current,
            pageSize: this.pageSize
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 文件下载 fileDownload
    async downloadFile(type, taskId, fileId) {
      try {
        // console.log(type, taskId, fileId);
        let res = await fileDownload({
          type: type,
          taskId: taskId,
          fileId: fileId
        });
        if (res.code === 200) {
          const downloadPath = res.data + '?Authorization=' + this.token;
          downloadFileApi(downloadPath);
        }
      } catch (err) {
        console.log(err);
      }
    },
    deleteCompanyFile(portfolioId, fileId,name) {
      let _this = this;
      this.$confirm({
        title: '提示',
        content: '确定删除「'+name+'」文件吗？',
        onOk() {
          _this.proxyDeleteCompanyFile(portfolioId, fileId );
        },
        onCancel() {}
      });

    },

    async proxyDeleteCompanyFile(portfolioId,fileId){
      try {
        // console.log("proxyDeleteCompanyFile:"+portfolioId, fileId);
        let res = await proxyDeleteCompanyFile({
          portfolioId: portfolioId,
          fileId: fileId
        });
        if (res.code === 200) {
          this.$message.success('删除成功');
          let i = this.tabNow;
          let fileUploadStartTime = "";
          if(this.fileUploadStartTime !== null && this.fileUploadStartTime !==undefined){
            fileUploadStartTime = this.fileUploadStartTime.format('YYYY-MM-DD HH:mm:ss');
          }
          let fileUploadEndTime = "" ;
          if(this.fileUploadEndTime !== null && this.fileUploadEndTime !== undefined){
            fileUploadEndTime = this.fileUploadEndTime.format('YYYY-MM-DD HH:mm:ss');
          }
          this.getTaskQuery({
            year: this.listQuarter[i].year,
            quarter: this.listQuarter[i].quarter,
            complete: this.filterNow,
            searchName: this.keyword,
            searchInvestFundIds: this.investFundNameKeyword.join(','),
            searchTaskFileName: this.taskFileNameKeyword,
            fileUploadStartTime: fileUploadStartTime,
            fileUploadEndTime: fileUploadEndTime,
            page: this.current,
            pageSize: this.pageSize
          });

        }
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>

<style lang="less" scoped>
@media screen and (max-width: 1440px) {
  .file-table {
    & /deep/ .ant-table-thead > tr > th {
      padding: 12px 12px;
      overflow-wrap: break-word;
      font-size: 12px;
    }
    & /deep/ .ant-table-tbody > tr > td {
      padding: 12px 12px;
      overflow-wrap: break-word;
      font-size: 12px;
    }

    & /deep/ .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
      background-color: white;
    }
  }
  .tab-description {
    margin-bottom: 15px;
    margin-left: 10px;
    font-size: 13px;
  }
}

@media screen and (min-width: 1441px) {
  .file-table {
    & /deep/ .ant-table-thead > tr > th {
      padding: 12px 12px;
      overflow-wrap: break-word;
      font-size: 14px;
    }
    & /deep/ .ant-table-tbody > tr > td {
      padding: 12px 12px;
      overflow-wrap: break-word;
      font-size: 14px;
    }

    & /deep/ .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
      background-color: white;
    }
  }
  .tab-description {
    margin-bottom: 15px;
    margin-left: 10px;
    font-size: 14px;
  }
}

.upload-info {
  line-height: 2;
  margin: 0 0 16px 0;
  div {
    display: inline-block;
    width: 100px;
    color: rgba(0, 0, 0, 0.5);
  }
}
.file-name {
  text-decoration: underline;
}

.file-name-del {
  color: rgba(0, 0, 0, 0.3);
  text-decoration: line-through underline;
}

.file-table-finish-time {
  margin: 0 5px;
  font-style: italic;
  color: rgba(0, 0, 0, 0.5);
}

.filter-selected {
}
.filter-unselected {
  color: rgb(24, 144, 255);
  cursor: pointer;
}
.list-name {
  cursor: pointer;
}
.list-header {
  display: flex;
  justify-content: space-between;
}
.list-header-top {
  display: flex;
  justify-content: flex-start;
}
.list-header-end {
  display: flex;
  justify-content: flex-end;
}
.file-path-track {
  display: flex;
  li {
    font-size: 14px;
    span {
      cursor: pointer;
    }
  }
}
.path {
  cursor: pointer;
}
.task-content {
  padding: 5px 0px;
}
.padding-10 {
  padding: 0px 30px;
}
.alert-msg {
  color: red;
  text-align: right;
  margin-top: 10px;
}
.pagination-buttom {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
}
.flex {
  display: flex;
}
.center {
  align-items: center;
}
.comment {
  padding: 10px 0px 0px 0px;
  display: border-box;
  p {
    font-size: 13px;
  }
  .blue {
    color: @blue;
  }
}
.spread-btn {
  position: absolute;
  right: 10px;
  width: 60px;
  bottom: 5px;
  color: #1890ff;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
}
</style>
